import { render } from "./EventsPage.vue?vue&type=template&id=2c0198aa&ts=true"
import script from "./EventsPage.vue?vue&type=script&lang=ts"
export * from "./EventsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__